import React from 'react'
import "../testimonial/Testimonial.css"
import { Col, Container, Row } from 'react-bootstrap'
const Testimonial = () => {
  return (
    <>
     <section id="testimonial">
      <Container>
        <div style={{display:'flex', justifyContent:'space-between', alignItems:'center'}}>
          <h1>Testimonial</h1>
          <p class="products_top_see">see all <i class="fa-solid fa-arrow-right-long"></i></p>
        </div>
        <Row style={{rowGap: '20px' , paddingTop:'20px'}}>
          <Col lg={6}>
            <div class="testimonial-inner">
              <div class="testimonial_main">
                <img src="imeges/desktop1/Testimonial-icon.png" alt=""/>
                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus suscipit tortor eget felis porttitor volutpat. Curabitur non nulla sit amet nisl tempus convallis quis ac lectus. Mauris blandit aliquet elit, eget tincidunt nibh pulvinar a. </p>
                <div class="testimonial_main_inner">
                  <div class="testimonial_main_inner_img">
                    <img src="imeges/desktop1/Testimonial img icon.png" alt=""/>
                  </div>
                  <div class="testimonial_main_inner_img">
                    <h5>Awlad Hossain</h5>
                    <p>UI Designer</p>
                  </div>
                </div>
              </div>
            </div>
          </Col>
          <Col lg={6}>
            <Row style={{rowGap: '20px'}}>
              <Col lg={12}>
                <div class="testimonial-inner">
                  <div class="testimonial-inner-main">
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus suscipit tortor eget felis porttitor volutpat. </p>
                    <div class="testimonial_main_inner justify-content-space-between">
                      <div class="testimonial_main_inner_img d-flex">
                        <div class="testimonial_main_inner_img_img ">
                          <img src="imeges/desktop1/Testimonial img icon 1.png" alt=""/>
                        </div>
                        <div class="testimonial_main_inner_img_text">
                          <h5>Flora smith</h5>
                          <p>Web Designer</p>
                        </div>
                      </div>
                      <div class="testimonial_main_inner_img_icon">
                        <img src="imeges/desktop1/Testimonial-icon-small.png" alt=""/>
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
              <Col lg={12}>
                <div class="testimonial-inner">
                  <div class="testimonial-inner-main">
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus suscipit tortor eget felis porttitor volutpat. </p>
                    <div class="testimonial_main_inner justify-content-space-between">
                      <div class="testimonial_main_inner_img d-flex">
                        <div class="testimonial_main_inner_img_img">
                          <img src="imeges/desktop1/Testimonial img icon 2.png" alt=""/>
                        </div>
                        <div class="testimonial_main_inner_img_text">
                          <h5>Emma watson</h5>
                          <p>CEO</p>
                        </div>
                      </div>
                      <div class="testimonial_main_inner_img_icon">
                        <img src="imeges/desktop1/Testimonial-icon-small.png" alt=""/>
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
  </section>
    </>
  )
}

export default Testimonial